import React, { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Colors, Typography } from '@inplayer-org/inplayer-ui';

// components
import { ContentContainer, CenterContent } from 'components/SharedStyledElements';

const StyledNavLink = styled(NavLink)`
  color: ${Colors.belizeHole};
  text-decoration: underline;
`;

const CodeAuth: FunctionComponent = () => {
  return (
    <ContentContainer>
      <CenterContent>
        <Typography variant="p">
          To complete the asset setup, go to the <StyledNavLink to="/vouchers">Vouchers</StyledNavLink> section, create
          an Access voucher, and add this asset to it. The voucher will contain the access duration period. Note that
          the Access voucher asset can only be used with the V3 version of the paywall. So make sure you use the Script
          V3 when getting the embed code for your asset.
        </Typography>
      </CenterContent>
    </ContentContainer>
  );
};

export default CodeAuth;
